import React from 'react';
import { Link } from 'react-router-dom';

const UnauthorizedPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        <h1 className="text-6xl font-bold text-indigo-600">403</h1>
        <h2 className="mt-2 text-3xl font-extrabold text-gray-900">
          Acceso no autorizado
        </h2>
        <p className="mt-2 text-sm text-gray-600">
          No tienes permisos para acceder a esta página.
        </p>
        <div className="mt-6">
          <Link
            to="/dashboard"
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
          >
            Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;